import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const dividerStyle = {
  background: "#F3F3F3",
  margin: "0px",
  padding: "0px"
}

const labelStyle = {
  fontSize: "1.2rem",
  fontWeight: "600"
}

const Divider = ({ label, ...rest }) => (
  <Grid.Row style={dividerStyle} {...rest}>
    <Grid.Column textAlign="left" width={15}>
      <span style={labelStyle}>{label}</span>
    </Grid.Column>
  </Grid.Row>
)

Divider.propTypes = {
  label: PropTypes.string.isRequired
}

export default Divider
